// How a job type works: decides which photos the crew adds, completion checks and the PDF layout.
export const KIND_OPTIONS = [
  { v: "standard", label: "Standard", hint: "before, after and completion photos" },
  { v: "delivery", label: "Drop-off", hint: "needs a drop-off photo" },
  { v: "site_clean", label: "Clean-up", hint: "before and after photos plus a list of what was removed" },
];

const t = (label, kind = "standard") => ({ label, kind });

export const STARTERS = [
  { key: "building", label: "Plastering & building", types: [t("Sheet & set"), t("Patch & repair"), t("Cornice"), t("Site clean", "site_clean"), t("Delivery", "delivery")] },
  { key: "mowing", label: "Lawn mowing & gardening", types: [t("Lawn mowing"), t("Hedge trimming"), t("Garden tidy-up"), t("Green waste removal", "site_clean"), t("Mulch & soil delivery", "delivery")] },
  { key: "cleaning", label: "Cleaning", types: [t("Regular clean"), t("End of lease clean"), t("Deep / spring clean"), t("Carpet clean"), t("Window clean"), t("Rubbish removal", "site_clean")] },
  { key: "painting", label: "Painting", types: [t("Interior painting"), t("Exterior painting"), t("Prep & patch"), t("Touch-ups"), t("Site clean", "site_clean")] },
  { key: "trades", label: "Electrical, plumbing & maintenance", types: [t("Service call"), t("Installation"), t("Repair"), t("Maintenance"), t("Quote / inspection")] },
  { key: "general", label: "Something else", types: [t("Standard"), t("Delivery", "delivery"), t("Site Clean", "site_clean")] },
];

const norm = (s) => (s || "").trim().toLowerCase();

// Swap in a starter list, keeping the id of any type with the same name so existing jobs stay linked.
export const applyStarter = (current, starter) =>
  starter.types.map((s) => {
    const same = current.find((c) => c.id && norm(c.label) === norm(s.label));
    return same ? { ...same, kind: s.kind } : { ...s };
  });

export const cleanTypes = (items) => items.map((x) => ({ ...x, label: x.label.trim() })).filter((x) => x.label);

export const hasLabel = (items, label) => items.some((x) => norm(x.label) === norm(label));
